import {Avatar, Typography} from '@mui/material';
import React, {useEffect, useState} from 'react';
import {generateRandomNumber, getColorByFirstName} from '../../../utils/utils';
import {AurLightTooltip} from '../aur-light-tooltip/aur-light-tooltip';

interface Props {
  bgColor?: boolean;
  displayText: string;
  iconSize: number;
  textSize: string;
  borderRadius: number;
  iconType: 'User' | 'Client' | 'PlusX';
  backgroundImage?: boolean;
  isPill?: boolean;
}
const clientProfileBackgroundImages = [
  '/assests/images/profileBackImage1.svg',
  '/assests/images/profileBackImage2.svg',
  '/assests/images/profileBackImage3.svg',
  '/assests/images/profileBackImage4.svg',
  '/assests/images/profileBackImage5.svg',
  '/assests/images/profileBackImage6.svg',
  '/assests/images/profileBackImage7.svg',
];
const AurProfilePicture: React.FC<Props> = (props: Props) => {
  const {
    bgColor,
    displayText,
    iconSize,
    textSize,
    borderRadius,
    iconType,
    backgroundImage,
    isPill = false,
  } = props;
  const [selectedImage, setSelectedImage] = useState('');
  useEffect(() => {
    const randomIndex = Math.floor(
      generateRandomNumber() * clientProfileBackgroundImages.length
    );
    setSelectedImage(clientProfileBackgroundImages[randomIndex]);
  }, []);
  return isPill ? (
    <AurLightTooltip title={`Total: ${parseInt(displayText, 10) + 5} users`}>
      <Avatar
        className="plusX-avatar"
        sx={{
          bgcolor: bgColor ? getColorByFirstName(displayText) : 'transparent',
          height: iconSize,
          minWidth: iconSize,
          width: 'auto',
          padding: '0 8px',
          gap: '10px',
          borderRadius: '100px',
          border: 'none',
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundImage: backgroundImage ? `url(${selectedImage})` : '',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'cover',
          whiteSpace: 'nowrap',
        }}
      >
        <Typography
          className={`typo-text profilePictureText${textSize}_size ${iconType}-profile-picture-text-color`}
        >
          {displayText}
        </Typography>
      </Avatar>
    </AurLightTooltip>
  ) : (
    <Avatar
      className={isPill ? 'plusX-avatar' : 'regular-avatar'}
      sx={{
        bgcolor: bgColor ? getColorByFirstName(displayText) : 'transparent',
        height: iconSize,
        minWidth: iconSize,
        width: isPill ? 'auto' : 32,
        padding: isPill ? '0 8px' : 0,
        gap: isPill ? '10px' : 0,
        borderRadius: isPill ? '100px' : `32px`,
        border: !isPill
          ? `${borderRadius}px solid rgba(76, 97, 129, 0.2)`
          : 'none',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundImage: backgroundImage ? `url(${selectedImage})` : '',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        whiteSpace: 'nowrap',
      }}
    >
      <Typography
        className={`typo-text profilePictureText${textSize}_size ${iconType}-profile-picture-text-color`}
        tabIndex={0}
      >
        {displayText}
      </Typography>
    </Avatar>
  );
};

export default AurProfilePicture;
